import * as actionType from "./Action_Type";
import createBrowserHistory from "history/createBrowserHistory";
import * as ROLES from "../Utils/Roles_Types";
import { URL_LOGIN, URL_LOGOUT } from "../Utils/Strings/URL.js";
import { USER_GET_INFO } from "../Utils/Strings/Service_Endpoint";
import { LABEL_Required, LABEL_PAGE_ErrorConnection } from "../Utils/Strings/Labels";
import { CALL_API } from "../Middlewares/api";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";
import { checkUserLanguage } from "../Utils/Check_Value.js";

let history = createBrowserHistory();

const USERLANGUAGE = checkUserLanguage();
//LOGIN
export const login_request = (info) => ({
    type            : actionType.AUTHENTICATION_LOGIN_REQUEST,
    isFetching      : true,
    isAuthenticated : false,
    id_token        : null,
    info           
});
export const login_success = (user) => ({
    type            : actionType.AUTHENTICATION_LOGIN_SUCCESS,
    isFetching      : false,
    isAuthenticated : true,
    id_token        : user.access_token,
    user
});
export const login_error = (msgError, msgUsername, msgPassword) => ({
    type            : actionType.AUTHENTICATION_LOGIN_ERROR,
    isFetching      : false,
    isAuthenticated : false,
    msgError        : msgError,
    usernameError   : msgUsername,
    passwordError   : msgPassword
});
export function login(userCred){
    let config = {
        method  : 'POST',
        headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        body    : `username=${userCred.username}&password=${userCred.password}&grant_type=password`
    };
    return dispatch => {
      dispatch(login_request(userCred));
      if(userCred.username === "" && userCred.password === "")
        return dispatch(login_error(null, LABEL_Required[USERLANGUAGE], LABEL_Required[USERLANGUAGE]));
    
      if(userCred.username === "")
        return dispatch(login_error(null, LABEL_Required[USERLANGUAGE], null));
        
      if(userCred.password === "")
        return dispatch(login_error(null, null, LABEL_Required[USERLANGUAGE]));

      return fetch(URL_LOGIN, config)
        .then(response =>
          response.json().then(user => ({ user, response }))
        )
        .then(({ user, response }) => {
          if (!response.ok) {
            return Promise.reject(user);
          } else {
            localStorage.setItem(ROLES.ROLES_KEY, user.role);
            localStorage.setItem(ROLES.TOKEN_KEY, user.access_token);
            dispatch(login_success(user));
            debugger;
            PAGESSWITCH.gotoPageWithParams(ROUTE.Home)
          }
        })
        .catch(err => {
          debugger;
            console.error(err.error_description);
            if(typeof err.error_description === 'undefined')
                err.error_description = LABEL_PAGE_ErrorConnection[USERLANGUAGE];
            dispatch(login_error(err.error_description));
          }
        );
    };
};

export function login_removeError (){
  return dispatch => dispatch(login_error(null, null, null));
}




//LOGOUT
export const logout_request = () => ({
  type       : actionType.AUTHENTICATION_LOGOUT_REQUEST,
  isFetching : true
});
export const logout_success = () => ({
  type: actionType.AUTHENTICATION_LOGOUT_SUCCESS,
  isFetching      : false,
  isAuthenticated : false
});
export const logout_error = () => ({
  type: actionType.AUTHENTICATION_LOGOUT_ERROR,
  isFetching : false
});
export const logout = () => {
  let config = {
      method  : 'POST',
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      headers: {
          Authorization: `Bearer ${localStorage.getItem(ROLES.TOKEN_KEY)}`,
          Accept: "application/json",
          "Content-Type": "application/json"
      },
  };
  return dispatch => {
      dispatch(logout_request());
      return fetch(URL_LOGOUT, config)
        .then(response =>{
          if(response.ok){
            localStorage.setItem(ROLES.USERINFO_KEY, null);
            localStorage.setItem(ROLES.TOKEN_KEY, null);
            localStorage.setItem(ROLES.ROLES_KEY, null);
            PAGESSWITCH.gotoPageWithParams(ROUTE.Root)
            dispatch(logout_success());
          }else{
            dispatch(login_error());
          }
        }
      );
  };
};


export function getUserInfo() {
  return {
    [CALL_API]: {
      endpoint: USER_GET_INFO,
      authenticated: true,
      types: [
        actionType.SERVICE_USERINFO_REQUEST,
        actionType.SERVICE_USERINFO_SUCCESS,
        actionType.SERVICE_USERINFO_ERROR
      ]
    }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_Authentication.js